import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Row, Col } from 'antd';
import Logo from '../../molecules/Logo/Logo';

import './Login.css';
import LoginForm from '../../../containers/LoginForm';

const Login = () => (
  <Row type="flex" justify="space-around" align="middle" className="container">
    <Col sm={16} md={16} lg={9}>
      <ReactCSSTransitionGroup
        transitionName="fadeElement"
        transitionAppear
        transitionEnterTimeout={1000}
        transitionAppearTimeout={1000}
        transitionLeaveTimeout={500}
      >
        <div className="content shadow">
          <Logo size="large" className="logo" />
          <LoginForm />
        </div>
      </ReactCSSTransitionGroup>
    </Col>
  </Row>
);

export default Login;
